<div class="container d-flex align-items-center justify-content-center">
  <div class="card">
    <fgb-register-success></fgb-register-success>
  </div>
</div>
